exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-controls span[data-v-9e432370],.my-dots .dot[data-v-9e432370]{margin:0 10px}.section[data-v-9e432370]{padding:0;width:100%}.my-slide[data-v-9e432370]{width:100%;height:100%;-webkit-transition:all .5s ease-in-out 0s;-o-transition:all .5s ease-in-out 0s;-moz-transition:all .5s ease-in-out 0s;transition:all .5s ease-in-out 0s}.my-slide .external[data-v-9e432370]{width:100%;display:none}.my-slide .external.active[data-v-9e432370]{display:block}.my-slide .external .item[data-v-9e432370]{position:relative;padding-top:66%;width:100%;display:inline-block;-moz-background-size:cover;background-size:cover;background-color:#000}", ""]);

// exports
